import { render, staticRenderFns } from "./EnrollmentOrderNew.vue?vue&type=template&id=a2a7c6fe&"
import script from "./EnrollmentOrderNew.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentOrderNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports